<template>
    <div class="file-list-table">
        <el-table
            :data="processingQueue"
            :empty-text="translate('messages.view.no_data')"
            highlight-current-row
        >
            <el-table-column
                min-width="140px"
                prop="nomeArquivo"
                :label="translate('file_table.file_name')"
                label-class-name="file-list-table_label"
            />
            <el-table-column
                min-width="120px"
                prop="tipoTransacao"
                :label="translate('file_table.operation')"
                label-class-name="file-list-table_label"
            >
                <template v-slot:default="scope">
                    <div class="file-list_text">
                        {{translate('file_table.' + scope.row.tipoTransacao.codigo.toLowerCase())}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                min-width="80px"
                prop="dataInicioProcessamento"
                :label="translate('file_table.start_date')"
                label-class-name="file-list-table_label"
            >
                <template v-slot:default="scope">
                    <div v-if="scope.row.dataInicioProcessamento">
                        <div>
                            {{ formatDateTimeToString(scope.row.dataInicioProcessamento)[0] }}
                        </div>
                        <div class="table_second-row-label">
                            <i class="mdi mdi-clock-outline"></i>
                            <span>{{ formatDateTimeToString(scope.row.dataInicioProcessamento)[1]}}</span>
                        </div>
                    </div>
                    <span v-else> - </span>
                </template>
            </el-table-column>
            <el-table-column
                min-width="80px"
                prop="dataFimProcessamento"
                :label="translate('file_table.end_date')"
                label-class-name="file-list-table_label"
            >
                <template v-slot:default="scope">
                    <div v-if="scope.row.dataFimProcessamento">
                        <div>
                            {{ formatDateTimeToString(scope.row.dataFimProcessamento )[0] }}
                        </div>
                        <div class="table_second-row-label">
                            <i class="mdi mdi-clock-outline"></i>
                            {{ formatDateTimeToString(scope.row.dataFimProcessamento )[1] }}
                        </div>
                    </div>
                    <span v-else> - </span>
                </template>
            </el-table-column>
            <el-table-column
                width="280px"
                prop="nomeUsuario"
                :label="translate('file_table.responsible')"
                label-class-name="file-list-table_label"
            >
                <template v-slot:default="scope">
                    <div v-if="scope.row.nomeUsuario">
                        <div class="file-list_text">
                            {{ scope.row.nomeUsuario }}
                        </div>
                        <div class="table_second-row-label file-list_text">
                            {{ scope.row.emailUsuario }}
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                min-width="80px"
                prop="status"
                :label="translate('file_table.status')"
                align="center"
                label-class-name="file-list-table_label"
            >
                <template v-slot:default="scope">
                    <div v-if="scope.row.status">
                        <el-tag :class="'tag-status-' + scope.row.status.toLowerCase()" type="primary" size="small" :round="false">
                            {{ getStatusLabel(scope.row.status) }}
                        </el-tag>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                :label="translate('file_table.actions')"
                align="center"
                label-class-name="file-list-table_label"
            >
                <template v-slot:default="scope">
                    <el-dropdown
                        class="action-button"
                        trigger="click"
                        @click="scope"
                    >
                        <span class="el-dropdown-link">
                            <i class="mdi mdi-dots-vertical" />
                        </span>
                        <el-dropdown-menu v-slot="dropdown">
                            <el-dropdown-item
                                icon="el-icon-download"
                                @click.native="handleDownloadSpreadsheet(scope.row, false)"
                            >
                                {{ translate('file_table.download_spreadsheet_original') }}
                            </el-dropdown-item>
                            <el-dropdown-item
                                v-if="scope.row.status === 'PROCESSADO_COM_ERRO'"
                                icon="el-icon-download"
                                @click.native="handleDownloadSpreadsheet(scope.row, true)"
                            >
                                {{ translate('file_table.download_spreadsheet_errors') }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <div class="file-list-table__pagination">
            <div class="total">
                <span
                    >{{ totalElements }}
                    {{
                        translate('messages.view.results')
                    }}</span
                >
                <div style="margin: 0 20px"></div>
                <span
                    >{{
                        translate('messages.view.views_by_page')
                    }}:</span
                >
                <el-pagination
                    @size-change="handleSizeChange"
                    :current-page="page"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="sizes"
                    :total="totalElements"
                />
            </div>
            <div class="prev_next">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page.sync="page"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="prev, pager, next, jumper"
                    :total="totalElements"
                />
            </div>
        </div>
    </div>
</template>

<script>
import FilaProcessamentoRastreabilidadeService from '@/services/FilaProcessamentoRastreabilidadeService';
import formatters from '@/utils/formatters';

export default {
    name: 'fileDefault',
    components: {
    },
    props: {
        filters: {
            type: Object,
            required: false,
            default: () => null
        }
    },
    data() {
        return {
            processingQueue: [],
            page: 0,
            size: 10,
            totalElements: 0
        };
    },
    computed: {
    },
    mounted() {
        this.fetchProcessingQueue();
    },
    watch: {
        filters: {
            handler(newVal) {
                this.fetchProcessingQueue();
            },
            deep: true
        }
    },
    methods: {
        translate(key, params = {}) {
            const base = 'warehouse';
            return this.$t(`${base}.${key}`, params);
        },
        handleSizeChange(size) {
            this.page = this.totalElements < size ? 1 : this.page;
            this.size = size;
            this.fetchProcessingQueue();
        },
        handleCurrentChange(page) {
            this.page = page;
            this.fetchProcessingQueue();
        },
        async fetchProcessingQueue() {
            if (this.filters) {
                await FilaProcessamentoRastreabilidadeService.fetchProcessingQueuePaginated(
                    {
                        searchText: this.filters.searchText,
                        status: this.filters.fileProcessingStatus,
                        tipoTransacao: this.filters.transactionType,
                        dataProcessamentoInicio: this.filters.initialDate_initial,
                        dataProcessamentoFinal: this.filters.initialDate_final,
                        dataFinalizacaoInicio: this.filters.endDate_initial,
                        dataFinalizacaoFim: this.filters.endDate_final
                    },
                    (this.page - 1), this.size
                ).then(({ data }) => {
                    this.processingQueue = data.content;
                    this.totalElements = data.totalElements;
                });
            }
        },
        formatDateTimeToString(dateTimeFromApi) {
            return formatters.splitApiDateTimeForTable(dateTimeFromApi, this.$i18n.locale);
        },
        getStatusLabel(status) {
            return this.translate('file_table.status_label.' + status.toLowerCase());
        },
        async handleDownloadSpreadsheet(row, planilhaErro = false) {
            let nomeArquivo = row.nomeArquivo;
            if (planilhaErro) {
                if (row.idiomaUsuario === 'pt-BR') {
                    nomeArquivo = 'ERRO_' + nomeArquivo;
                } else {
                    nomeArquivo = 'ERROR_' + nomeArquivo;
                }
            }
            await FilaProcessamentoRastreabilidadeService.downloadPlanilha(row.id, nomeArquivo, planilhaErro)
                .then(() => {
                    this.$notify.success({
                        message: this.translate('messages.file_downloaded_successfully')
                    });
                })
                .catch(() =>
                    this.$notify.error({
                        message: this.translate('messages.error_downloading_file')
                    })
                );
        }
    }
};
</script>

<style scoped lang="scss">
.file-list-table {
    margin-top: -8px;
    .el-table {
        .action-button {
            cursor: pointer;
        }
    }
    .file-list-table__pagination {
        display: grid;
        grid-template-columns: 2fr auto;
        margin-top: 20px;
        @media (max-width: 768px) {
            grid-template-columns: 1fr;
        }

        .total {
            display: flex;
            align-items: center;
            @media (max-width: 768px) {
                flex-direction: column;
            }
        }

        .prev_next {
            display: flex;
            @media (max-width: 768px) {
                justify-content: center;
                margin-top: 20px;
            }
        }
    }
}
.level1-label {
    font-size: 12px;
    color: #7c7c7c !important;
}
::v-deep .file-list-table_label {
    word-break: keep-all !important;
}
.file-list_text {
    word-break: keep-all !important;
}
.tag-status-solicitado {
    color: #525252;
    background-color: transparent;
    border: 1px solid #E0E0E0;
    border-radius: 4px !important;
}
.tag-status-em_processamento {
    color: #525252;
    background-color: #F5F5F5;
    border: 1px solid #E0E0E0;
    border-radius: 4px !important;
}
.tag-status-processado {
    color: #1F5B21;
    background-color: #EBF4EB;
    border: 1px solid #C0DDC1;
    border-radius: 4px !important;
}
.tag-status-processado_com_erro {
    color: #6D4D09;
    background-color: #FDF7E8;
    border: 1px solid #F9E5B9;
    border-radius: 4px !important;
}
.tag-status-erro {
    color: #991F1A;
    background-color: #FCEBEA;
    border: 1px solid #F4C1BE;
    border-radius: 4px !important;
}
.table_second-row-label {
    color: #7C7C7C !important;
    font-size: 12px;
}
</style>
